import "core-js/stable";
import "regenerator-runtime/runtime";
import { setupComponents } from "../setup";
import Vue, { createApp, configureCompat } from "vue";
import App from "../App";
import router, { Router } from "../router";
import store, { setupStore } from "../store";
import { USER_KIND_PARENT } from "@/constants";
import { setupScroll } from "../setupVueScrollTo";
import { setupCompat } from "@/compat";

if (process.env.VUE_APP_COMPAT) {
  configureCompat({ WATCH_ARRAY: false });

  const app = createApp(App);

  app.use(router);
  setupStore(app, USER_KIND_PARENT);
  setupComponents(app.config.globalProperties, app);
  setupScroll(app);
  setupCompat(app);

  app.mount("#app");
} else {
  Vue.use(Router);
  setupStore(Vue, USER_KIND_PARENT);
  setupComponents(Vue.prototype, Vue);
  setupScroll(Vue);
  setupCompat(Vue);

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
